// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pre[data-v-bc99fe32] {\n  white-space: pre;\n}\n", ""]);
// Exports
module.exports = exports;
